export default function ScrollToSection(): null {
  const elId = window.location.hash;
  if (elId.length > 1) {
    const el = document.getElementById(elId.substr(1));
    if (el) el.scrollIntoView(true);
  }

  return null;
}
